import { useEffect, useRef } from 'react';

export type CelebrateTargetParams = {
  target: number | null | undefined;
  currentValue: number;
  isToday: boolean;
  localStorageKey: string;
  lastUpdated: Date;
  onTargetAchieved: (target: number, updatedDate: Date) => void;
  enabled?: boolean;
};

export const useCelebrateTarget = ({
  target,
  currentValue,
  isToday,
  lastUpdated,
  localStorageKey,
  onTargetAchieved,
  enabled = true,
}: CelebrateTargetParams) => {
  const prevTargetRef = useRef<number | null | undefined>(target);

  useEffect(() => {
    const prevTarget = prevTargetRef.current;
    const isNewTarget = target !== prevTarget;
    const achieved = target != null && currentValue >= target;

    if (isNewTarget && !achieved) {
      localStorage.removeItem(localStorageKey);
    }

    if (achieved && isToday && enabled && localStorage.getItem(localStorageKey) !== 'true') {
      localStorage.setItem(localStorageKey, 'true');
      onTargetAchieved(target, lastUpdated);
    }

    prevTargetRef.current = target;
  }, [target, currentValue, isToday, enabled, lastUpdated, localStorageKey, onTargetAchieved]);
};
